import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../services/firebase"; // Import initialized Firebase app
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const SellerAuthContext = createContext();

export function useSellerAuth() {
  return useContext(SellerAuthContext);
}

export function SellerAuthProvider({ children }) {
  const [currentSeller, setCurrentSeller] = useState(null);
  const [registrationData, setRegistrationData] = useState({
    email: "",
    password: "",
    phoneNumber: "",
    mobileMoneyNumber: "",
    ghanaCardId: "",
  });
  const registerSeller = async (email, password) => {
    try {
      // Check if the email is already registered
      const signInMethods = await fetchSignInMethodsForEmail(auth, email);

      if (signInMethods.length > 0) {
        throw new Error("This email is already in use. Please login instead.");
      }

      // Register the seller if the email is not in use
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      return userCredential.user;
    } catch (error) {
      console.error("Error during seller registration:", error.message);
      throw error;
    }
  };

  // Login Seller
  const loginSeller = async (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  // Logout Seller
  const logoutSeller = () => signOut(auth);

  const verifyPhoneNumber = async (phoneNumber, recaptchaContainer) => {
    const provider = new auth.PhoneAuthProvider();
    const verificationId = await provider.verifyPhoneNumber(
      phoneNumber,
      recaptchaContainer
    );
    return verificationId;
  };

  const saveSellerDetails = async (uid, mobileMoneyNumber, ghanaCardId) => {
    await db.collection("sellers").doc(uid).update({
      mobileMoneyNumber,
      ghanaCardId,
    });
  };

  // Fetch seller details (for example, to confirm whether the Ghana Card is already saved)
  const getSellerDetails = async (sellerId) => {
    const sellerDocRef = doc(db, "sellers", sellerId);
    const docSnap = await getDoc(sellerDocRef);
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      console.log("No such document!");
    }
  };

  // Keep track of the current seller (authentication state observer)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentSeller(user);
    });
    return unsubscribe; // Cleanup on component unmount
  }, []);

  const value = {
    registrationData,
    setRegistrationData,
    currentSeller,
    registerSeller,
    loginSeller,
    logoutSeller,
    verifyPhoneNumber,
    saveSellerDetails,
    getSellerDetails,
  };

  return (
    <SellerAuthContext.Provider value={value}>
      {children}
    </SellerAuthContext.Provider>
  );
}
